<script setup>

// Props
const props = defineProps({
  block: {
    type: Object,
    default: () => ({})
  }
})

// Lifecycle
// onMounted(() => {
//   console.log(props.block)
// })

</script>

<!-- -------------------------------------------------------------------------------------------------
    Template
------------------------------------------------------------------------------------------------- -->

<template>
  <section class="section section-mb cta-compact">
    <div class="container">
      <div>
        <div class="cta-compact__wrapper">
          
          <GlobalsImage
            :landscape="block.ctaContent?.[0]?.backgroundImageDesktop"
            :portrait="block.ctaContent?.[0]?.backgroundImageMobile"
            class="cta-compact__bg"
            :alt="block.ctaContent?.[0]?.heading?.plainText"
          />
          
            <div class="cta-compact__content">
            <div class="cta-compact__content-wrapper">
              <div class="cta-compact__header"
                v-html="block.ctaContent?.[0]?.heading?.html"></div>
              <div class="cta-compact__btn">
                <GlobalsButton :url="block?.['ctaContent']?.[0]?.button?.url"
                  :title="block?.['ctaContent']?.[0]?.button?.title"
                  :type="block?.['ctaContent']?.[0]?.buttonSettings?.linkType"
                  :size="block?.['ctaContent']?.[0]?.buttonSettings?.linkSize"
                  :icon="block?.['ctaContent']?.[0]?.buttonSettings?.linkIcon"
                  :popup-enabled="Boolean(block?.['ctaContent']?.[0]?.buttonSettings?.popupEnabled ?? block?.['ctaContent']?.[0]?.popupEnabled)"
                  :popup-form-id="block?.['ctaContent']?.[0]?.popupFormId"
                  :bgColor="block?.['ctaContent']?.[0]?.buttonColor" />
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<!-- -------------------------------------------------------------------------------------------------
    Styling
------------------------------------------------------------------------------------------------- -->

<style scoped>

.cta-compact {
  color: #fff;
}

.cta-compact__wrapper {
  overflow: hidden;
  position: relative;
  border-radius: 16px;
}

.cta-compact__bg {
  bottom: 0;
  left: 50%;
  position: absolute !important;
  top: 0;
  transform: translateX(-50%);
  width: 100%;
}

.cta-compact__content {
  position: relative;
  height: 100%;
}

.cta-compact__header {
  margin-bottom: 38px;
  text-align: center;
}

.cta-compact__header :deep(*) {
  font-family: var(--font-family-heading);
  font-size: 40px;
  font-weight: 500;
  line-height: 110%; /* 44px */
  letter-spacing: -0.8px;
  color: var(--color-gray-800);
}

.cta-compact__btn {
  display: flex;
}

@media (max-width: 767px) {
  .cta-compact__header :deep(br) {
    display: none;
  }
}

@media (max-width: 743px) {
  .cta-compact__wrapper {
    overflow: visible;
  }

  .cta-compact__btn {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .cta-compact__bg {
    width: calc(100% + 32px);
  }

  .cta-compact__content-wrapper {
    padding: 94px 0;
  }
}

@media (min-width: 744px) {
  .cta-compact__content-wrapper {
    text-align: left;
    padding: 64px 32px;
  }

  .cta-compact__header {
    text-align: left;
    margin-bottom: 30px;
  }
}

@media (min-width: 1024px) {
  .cta-compact__content-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .cta-compact__header {
    width: 68%;
    max-width: 1027px;
    margin-bottom: 0;
  }

  .cta-compact__header :deep(*) {
    font-size: 38px;
    font-weight: 500;
    line-height: 120%; /* 45.6px */
    letter-spacing: -0.76px;
  }
}

@media (min-width: 1440px) {
  .cta-compact__content-wrapper {
    padding: 64px 96px 64px 64px;
  }

  .cta-compact__header {
    width: 74%;
  }
}

</style>